var exports = {
  "cj": "x61f99309--99585b--chats_container",
  "p_": "x61f99309--99585b--list",
  "kv": "x61f99309--99585b--chats_container--desktop_frame",
  "TE": "x61f99309--99585b--chat",
  "UZ": "x61f99309--99585b--with_bottom_navigation",
};

module.exports = exports;
